import * as React from 'react'
import { Link } from 'gatsby'
import {
  IconFacebook,
  IconInstagram,
  IconLinkedIn,
  IconPinterest,
  IconXTwitter,
  IconYouTube,
} from '../../icons/IconSocial'
import { GnsLogo, IconChevronLeft } from '../Icons'
import PropTypes from 'prop-types'
import FormWrapper from '../form/FormWrapper'
import isEmail from '../form/validators/isEmail'
import useFormState from '../form/hooks/useFormState'
import InputField from '../form/InputField'
import { StaticImage } from 'gatsby-plugin-image'
import PaymentMethods from './PaymentMethods'
import { useWidgetState } from '@livechat/widget-react'
import { openChat } from '../../state/popupForms'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { CHAT_STATE_OPEN } from '../../state/popupForms'
import EmailLink from '../EmailLink'
import LocationLink from '../LocationLink'
import PhoneLink from '../PhoneLink'

const FooterAlt = ({ className }) => {
  const widgetState = useWidgetState()
  const [greetingBubbleState, setGreetingBubbleState] = React.useState('initial')
  const { chatState } = useSelector(state => state.popupForms)

  const FooterLink = ({ to, children, className }) => {
    return (
      <Link to={to} className={'text-black hover:text-red-600 duration-150 ' + className}>
        {children}
      </Link>
    )
  }
  FooterLink.propTypes = {
    to: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
  }

  React.useEffect(() => {
    if (greetingBubbleState !== 'initial') return
    if (chatState === CHAT_STATE_OPEN) return
    if (widgetState?.availability !== 'online') return
    const timeout = setTimeout(() => {
      setGreetingBubbleState('display')
    }, 5000)
    return () => {
      clearTimeout(timeout)
    }
  }, [greetingBubbleState, widgetState, chatState])

  React.useEffect(() => {
    if (greetingBubbleState !== 'display') return
    const timeout = setTimeout(() => {
      setGreetingBubbleState('hidden')
    }, 5000)
    return () => {
      clearTimeout(timeout)
    }
  }, [greetingBubbleState])

  // const handlegreetingBubbleState = () => {
  //   setGreetingBubbleState('closed')
  // }
  const [form, , updateForm] = useFormState({
    email: '',
  })
  const dispatch = useDispatch()
  const openChatHandler = React.useCallback(e => {
    e.preventDefault()
    // if (window?.LC_API?.open_chat_window) {
    //   window.LC_API.open_chat_window()
    //   setGreetingBubbleState('closed')
    // }
    dispatch(openChat())
    setGreetingBubbleState('closed')
  }, [])
  // noinspection HtmlUnknownAnchorTarget

  const [hideTextBubble, setHideTextBubble] = React.useState(false)

  const hideTextBubbleHandler = React.useCallback(() => {
    setHideTextBubble(true)
  })
  return (
    <footer
      className={className + ' bg-gray-200 w-full mb-12 md:mb-0 relative overflow-hidden'}
      itemScope
      itemType="https://schema.org/WPFooter"
    >
      <div className="mx-auto flex px-4 md:w-10/12 flex-col ">
        <div className=" grid lg:grid-cols-2 justify-center mx-auto w-full">
          <div className="w-max mx-auto items-center lg:mx-0 justify-start ">
            <h3 className="border-4">
              <GnsLogo className="w-full aspect-[3/1] " />
            </h3>
            <div className="w-max flex flex-row gap-3 pb-5 justify-center items-center px-5">
              <a
                href={'https://www.facebook.com/grayandsonsjewelers'}
                rel={'nofollow noopener noreferrer'}
                target={'_blank'}
                className="size-10 aspect-square rounded-full text-gray-600 hover:text-red-600 flex justify-center items-center"
              >
                <span className="sr-only text-black">Facebook</span>
                <IconFacebook className={'w-full h-full '} />
              </a>{' '}
              <a
                href={'https://www.instagram.com/grayandsons'}
                rel={'nofollow noopener noreferrer'}
                target={'_blank'}
                className="size-10 aspect-square rounded-full text-gray-600 hover:text-red-600 flex justify-center items-center"
              >
                <span className="sr-only text-black">Instagram</span>
                <IconInstagram className={'w-full h-full '} />
              </a>
              <a
                href={'https://www.youtube.com/user/grayandsons'}
                rel={'nofollow noopener noreferrer'}
                target={'_blank'}
                className="size-10 aspect-square rounded-full text-gray-600 hover:text-red-600 flex justify-center items-center"
              >
                <span className="sr-only text-black">Youtube</span>
                <IconYouTube className={'w-full h-full '} />
              </a>{' '}
              <a
                href={'https://x.com/grayandsons'}
                rel={'nofollow noopener noreferrer'}
                target={'_blank'}
                className="size-9 aspect-square bg-gray-600 rounded-full p-2 text-white hover:bg-red-600 flex justify-center items-center"
              >
                <span className="sr-only text-black">X Twitter</span>
                <IconXTwitter className={'w-full h-full '} />
              </a>
              <a
                href={'https://www.pinterest.com/grayandsons/'}
                rel={'nofollow noopener noreferrer'}
                target={'_blank'}
                className="size-9 aspect-square bg-gray-600 rounded-full p-2 text-white hover:bg-red-600 flex justify-center items-center"
              >
                <span className="sr-only text-black">Pinterest</span>
                <IconPinterest className={'w-full h-full '} />
              </a>
              <a
                href={'https://www.linkedin.com/company/grayandsons/posts/'}
                rel={'nofollow noopener noreferrer'}
                target={'_blank'}
                className="size-9 aspect-square bg-gray-600 rounded-full p-2 text-white hover:bg-red-600 flex justify-center items-center"
              >
                <span className="sr-only text-black">Linked In</span>
                <IconLinkedIn className={'w-full h-full '} />
              </a>
            </div>
          </div>
          <FormWrapper
            action={'/thank-you-email-subscribe/'}
            form={form}
            name={'Footer Newsletter Subscribe'}
            className="grid grid-cols-[1fr_auto] grid-rows-[1fr_auto_auto] lg:justify-items-end w-full grid-flow-col py-4"
            conversionEventName={'email_subscribe'}
          >
            <label className="w-full text-right col-span-2 text-lg uppercase " htmlFor="subscribe">
              $200 Coupon for New Subscribers
            </label>
            <div className="w-full max-w-[600px] flex flex-row pb-2">
              <InputField
                form={form}
                name="email"
                id="subscribe"
                onChange={updateForm}
                required={true}
                validator={isEmail}
                label="Enter your E-Mail"
                className="max-w-[500px]"
              />
              <button className="h-12 px-4 w-full max-w-[150px] border-2 border-red-600 bg-red-600 py-2 text-center mt-4 font-bold text-white">
                SUBSCRIBE
              </button>
            </div>
            <p className="text-xs block w-full col-span-2 text-right">
              *Offer limited to items priced $750 or more. Excludes sale items and may not be
              combined with other discounts.
            </p>
          </FormWrapper>{' '}
        </div>
        <div className="mb-5 grid grid-cols-2 lg:grid-cols-4 w-full gap-8 md:gap-5 pt-10 text-sm md:pt-0 md:text-base xl:ml-[33.33%] xl:w-2/3 max-w-max md:max-w-full mx-auto ">
          <div className="flex flex-col gap-2 justify-start">
            <h4 className="font-bold uppercase lg:h-16">Our Company</h4>
            <FooterLink to="/about-us/">About Us</FooterLink>
            <FooterLink to="/ourstory/">Our Story</FooterLink>
            <FooterLink to="/grayandsons-fanclub/">Fan Club</FooterLink>
            <FooterLink to="/testimonials/">Our Reviews</FooterLink>
            <FooterLink to="/faq/">FAQ</FooterLink>
          </div>
          <div className="flex w-full flex-col gap-2 justify-start">
            <h4 className="font-bold uppercase lg:h-16"> Our Services</h4>
            <FooterLink to="/what-s-new/">
              <span>Shop</span>
            </FooterLink>
            <a
              className="text-black hover:text-red-600"
              href="https://sellusyourjewelry.com/?utm_source=referral&utm_medium=grayandsons"
            >
              <span>Sell to Us</span>
            </a>
            <FooterLink to="/repairs/">
              <span>Repairs</span>
            </FooterLink>
            <FooterLink to="/catalog-request/">
              <span>Catalog Request</span>
            </FooterLink>
            <FooterLink to="/blog/">
              <span>Blogs</span>
            </FooterLink>
          </div>
          <div className="flex w-full flex-col gap-2 justify-start">
            <h4 className="font-bold uppercase lg:h-16">Customer Service</h4>
            <FooterLink to="/warranty-and-policies/">Warranty</FooterLink>
            <FooterLink to="/returns/">10-Day Return Policy</FooterLink>
            <FooterLink to="/financing/">Affirm Financing</FooterLink>
            <FooterLink to="/shipping/">Shipping Rates</FooterLink>

            <FooterLink to="/glossary/">Glossary</FooterLink>
          </div>
          <div className="flex w-full flex-col justify-start">
            <div className="h-16 font-bold uppercase gap-2">
              <h4>
                <FooterLink to="/contact/">Contact Us </FooterLink>
              </h4>
            </div>
            <div className=" whitespace-pre-line flex w-full flex-col gap-2 justify-start">
              <LocationLink className="text-black hover:text-red-600 lg:leading-[2rem]">
                9595 Harding Avenue{'\n'}Miami Beach, FL 33154{'\n'}
              </LocationLink>
              <PhoneLink className="block hover:text-red-600" />
              <EmailLink className="block hover:text-red-600"/>
              <FooterLink to="/locations/">Areas we Serve</FooterLink>
            </div>
          </div>
        </div>
        <div className="mx-auto flex flex-row py-3 text-sm md:mx-0 flex-wrap justify-center md:justify-between gap-4">
          <div className="flex flex-row gap-5">
            <FooterLink to="/privacy-policy-cookie-restriction-mode/">PRIVACY POLICY</FooterLink>
            <FooterLink to="/accessibility/">ACCESSIBILITY</FooterLink>
            <FooterLink to="/sitemap/">SITEMAP</FooterLink>
          </div>
          <div>
            <PaymentMethods />
          </div>
        </div>
      </div>
      <a
        target="_blank"
        rel={'noreferrer'}
        href={'https://www.dibbyglobal.com/'}
        className="mx-auto block w-10/12 border-t border-gray-300 py-2 text-center text-sm text-gray-700 hover:text-red-600 md:text-base"
      >
        © {new Date().getFullYear()} Gray & Sons Jewelers | Created with care by Dibby Global
      </a>
      <a
        href="#top"
        onClick={e => {
          e.preventDefault()
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }}
        className="group flex h-12 max-w-full w-full items-center justify-center bg-gray-600 text-center font-bold text-white duration-300 hover:bg-gray-700"
      >
        <IconChevronLeft className="mr-3 h-5 w-5 rotate-90 rounded-full border border-white p-1 duration-200 group-hover:-translate-y-1" />
        BACK TO TOP
      </a>
      <div className="fixed md:hidden bottom-0 mt-12 z-[100] h-12  min-w-screen w-screen text-sm md:text-base  flex flex-row gap-1 bg-white p-1 font-bold text-white shadow-[0_10px_20px_15px_rgba(0,0,0,0.4)] ">
        <PhoneLink className="h-full w-full bg-red-600 block text-center py-2">
          CALL
        </PhoneLink>
        <LocationLink
          className="h-full w-full py-2 bg-red-600 block text-center"
        >
          VISIT
        </LocationLink>
        <EmailLink className="h-full w-full bg-red-600 block text-center py-2" >
          EMAIL
        </EmailLink>
        <button onClick={openChatHandler} className="h-full w-full bg-red-600 relative">
          {/* TODO: deactivate this jumping "!" after someone has opened the chat so it is not bouncing after they close it */}
          {greetingBubbleState !== 'closed' && (
            <div
              className={
                (greetingBubbleState === 'hidden'
                  ? ' delay-300 -top-4 opacity-100 '
                  : ' -top-12 opacity-0 ') +
                ' absolute animate-bounce right-2 size-6 bg-red-500 border border-white shadow-md text-white font-bold flex justify-center items-center rounded-full duration-500 ease-in-out '
              }
            >
              !
            </div>
          )}
          CHAT
        </button>
      </div>

      {/* Chat Popup Widget */}
      <div className={' fixed bottom-12 right-3 h-20 max-w-max z-[43]'}>
        {/* Viktoria's picture bubble */}
        <button
          onClick={openChatHandler}
          className={
            (greetingBubbleState === 'initial'
              ? '-right-36 '
              : greetingBubbleState !== 'display'
              ? ' -right-36 md:right-3 '
              : ' right-3 ') +
            ' aspect-square rounded-full size-16 drop-shadow-lg absolute top-2 overflow-hidden duration-500 ease-[cubic-bezier(1,-0.49,.12,1.68)]'
          }
        >
          <StaticImage
            alt="Livechat with Viktoria image"
            src={'../../images/viktoria-livechat.jpeg'}
            loading="eager"
            imgStyle={{ objectFit: 'contain' }}
            className="w-full h-full mt-2 aspect-square rounded-full scale-[125%] saturate-[115%]"
          />
        </button>
        <div
          className={
            (greetingBubbleState === 'initial'
              ? '-right-36 '
              : greetingBubbleState !== 'display'
              ? '-right-36 md:right-3 '
              : ' right-3 ') +
            ' absolute top-1 border-b border-b-green-800 size-4 bg-green-500 before:animate-pulse rounded-full before:content-[""] before:bg-lime-400 before:absolute before:top-0 before:left-0 before:w-full before:h-full before:rounded-full shadow-md after:content[""] after:absolute after:top-[.15rem] after:left-1 after:size-2  after:rounded-full after:border-t after:border-white after:m-auto z-[43] duration-500 ease-[cubic-bezier(1,-0.49,.12,1.68)]'
          }
        />

        {hideTextBubble ? null : (
          <div
            className={
              (greetingBubbleState === 'initial'
                ? ' duration-500 top-48 md:top-[25rem] -z-10 '
                : greetingBubbleState !== 'display'
                ? ' duration-500 top-48  md:-top-14 -z-10 '
                : ' duration-1000 delay-200 top-4 md:-top-14 h-14 z-10 ') +
              ' group min-w-60 -bottom-2 right-20 md:bottom-20 md:right-4 md:max-w-[300px] absolute  bg-gradient-to-b w-full from-gray-100 text-sm to-white border border-gray-200 bg-white shadow-lg rounded-lg max-w-[calc(100%-8rem)] ml-5 px-5 flex justify-center items-center  ease-[cubic-bezier(1,-0.49,.12,1.68)] text-center'
            }
          >
            <button
              onClick={openChatHandler}
              className={
                (greetingBubbleState !== 'display'
                  ? ' opacity-0 md:opacity-100 '
                  : ' opacity-100 ') + ' duration-150 line-clamp-2 '
              }
            >
              Found something you love? Work out a deal with me now.
            </button>
            <button
              onClick={hideTextBubbleHandler}
              className={
                (greetingBubbleState === 'display'
                  ? ' delay-1000 translate-y-0 opacity-100 '
                  : ' -translate-y-10 opacity-0  md:translate-y-0 md:opacity-0 group-hover:opacity-100 ') +
                'absolute -top-4 -left-6 ml-2 size-10 rounded-full after:absolute after:top-1 after:left-1 after:rounded-full after:content-[""] after:bg-red-600 after:size-8 after:-z-10 text-white z-30 duration-300 ease-in-out md:group-hover:translate-y-0 md:group-hover:opacity-100 '
              }
            >
              &#10005;
            </button>
          </div>
        )}
      </div>
    </footer>
  )
}

FooterAlt.propTypes = {
  className: PropTypes.string,
}

export default FooterAlt
